import { ImageUpIcon } from 'lucide-react'
import React, { type ChangeEvent, type DragEvent, useCallback, useState } from 'react'

const ImageUpload: React.FC = () => {
  const [image, setImage] = useState<string | null>(null)

  const handleDrop = useCallback((event: DragEvent<HTMLDivElement>) => {
    event.preventDefault()
    event.stopPropagation()

    const files = event.dataTransfer.files
    if (files && files[0]) {
      const reader = new FileReader()
      reader.onload = (e) => {
        setImage(e.target?.result as string)
      }
      reader.readAsDataURL(files[0])
    }
  }, [])

  const handleFileSelect = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files
    if (files && files[0]) {
      const reader = new FileReader()
      reader.onload = (e) => {
        setImage(e.target?.result as string)
      }
      reader.readAsDataURL(files[0])
    }
  }

  return (
    <div
      onDragOver={(e) => e.preventDefault()}
      onDrop={handleDrop}
      className='border-2 border-dashed border-thatch-gray-secondary rounded-lg w-72 h-48 flex items-center justify-center relative cursor-pointer overflow-hidden'
    >
      {image
        ? (
          <img
            src={image}
            alt='Uploaded'
            className='object-cover w-full h-full rounded-lg'
          />
          )
        : (
          <div className='text-thatch-gray-secondary flex flex-col items-center space-y-1'>
            <ImageUpIcon size={24} />
            <p>Drag & drop an image here or</p>
            <button
              className='text-thatch-purple-secondary underline bg-none border-none cursor-pointer'
              onClick={() => document.getElementById('fileInput')?.click()}
            >
              Select a file
            </button>
            <input
              id='fileInput'
              type='file'
              className='hidden'
              onChange={handleFileSelect}
            />
          </div>
          )}
    </div>
  )
}

export default ImageUpload
